import type { IService, IServicePriceSettings, IServicePriceSettingsParam } from '@types'
import { ServiceBlockBookingTypes, ServiceFormats, ServiceTypes } from '@types'
import { differenceInHours, minutesToMilliseconds } from 'date-fns'
import { hmToTMinutes } from '../minutes'

const DEFAULT_BREAK = 0
export function getServiceBreak(service: IService): number {
  return (service.breakIsEnable && +service.break) || DEFAULT_BREAK
}

export function isPriceParamIncludePeriod(
  param: Pick<IServicePriceSettingsParam, 'timeStart' | 'timeEnd'>,
  { dateStart, dateEnd }: { dateStart: Date; dateEnd: Date },
): boolean {
  const bookingStart = hmToTMinutes(dateStart.getMinutes(), dateStart.getHours())
  const bookingEnd = hmToTMinutes(dateEnd.getMinutes(), dateEnd.getHours())
  if (differenceInHours(dateEnd, dateStart) >= 24) {
    return true
  }
  const timeStart = +param.timeStart
  const timeEnd = +param.timeEnd
  if (bookingEnd < bookingStart) {
    return (bookingStart < timeEnd && timeStart < 1440) || (timeEnd > 0 && timeStart < bookingEnd)
  }
  return bookingStart < timeEnd && timeStart < bookingEnd
}

// TODO почему 2 разные реализации?
export function getServiceMinLength(service?: IService): number {
  return Number(service?.type === ServiceTypes.Rent ? service.minTimeLength : service?.timeLength) || 0
}

export function getServiceMinTimeLength(
  service: IService,
  priceSettings: IServicePriceSettings[],
  { dateStart, dateEnd }: { dateStart: Date; dateEnd: Date },
): number {
  const { minTimeLength, timeLength } = service

  if ([ServiceTypes.Individual, ServiceTypes.GroupService].includes(service.type)) {
    return +timeLength
  }

  if (service.format !== ServiceFormats.without) {
    const parameters = priceSettings
      ?.reduce<IServicePriceSettingsParam[]>((val, cur) => val.concat(cur.parameters), [])
      .filter(param => {
        if (!dateStart) {
          return true
        }
        return isPriceParamIncludePeriod(param, { dateStart, dateEnd })
      })
      .map(param => hmToTMinutes(param.durationMinutes, param.durationHour))

    if (!parameters?.length) {
      return +minTimeLength
    }

    return +Math.max(+minTimeLength, Math.min(...parameters))
  }

  return +minTimeLength
}

export function getServiceFixLength(service?: IService): number {
  return service && [ServiceTypes.Individual, ServiceTypes.GroupService].includes(service.type)
    ? +service.timeLength || 0
    : 0
}

export function getBlockBooking(service: IService): number {
  if (service.blockBookingIsEnable) {
    const amount = +service.blockBookingTime
    return minutesToMilliseconds(
      service.blockBookingType === ServiceBlockBookingTypes.M ? amount : hmToTMinutes(0, amount),
    )
  }

  return 0
}
